import Flickity from 'flickity'

export default function () {
  var galleryElems = document.querySelectorAll('.articles-carousel')

  if (galleryElems.length) {
    for (var i = 0, len = galleryElems.length; i < len; i++) {
      var galleryElem = galleryElems[i]
      new Flickity(galleryElem, {
        cellAlign: 'center',
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        watchCSS: true
      })

      // Have lazysizes reevaluate the responsive images after flickity has changed their width
      // lazySizes is a global
      lazySizes.autoSizer.checkElems()
    }
  }
}
